import React  from 'react';
import '../Styles/AboutUs.css';
import { Container} from 'react-bootstrap';
function AboutUs() {
  
    return (
        <div>
            <Container fluid>
                <section className='aboutus_block'>
                    <div className='about_irock'>
                        <h1 data-aos="flip-up" data-aos-duration="1000" data-aos-easing="ease-in" className='irock_head_about'>About I-Rock</h1>
                        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" className='para_body'>Independence Rock is where India’s rock and metal scene was born, and it brought to life the spirit of rebellion and exhilaration that our music scene is now known for. Since 1986, I-Rock was the place where musicians became legends and the next generation of bands showcased their talent to roaring audiences in black tees. It was not just an integral part of the scene - for many years, it WAS the scene.</p>
                        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" className='para_body'>And hell yeah… it’s back baby.</p>
                        
                        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" className='para_body'>Same ethos, same vision, in a new venue and new avatar.
                        I-Rock is back - bigger, louder, and prouder.</p>
                        
                        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" className='para_body'>Yesterday’s legends. Today’s largest names. Tomorrow’s headliners.</p>
                        
                        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out"  className='para_body'>They’re all coming soon to a stage near you. Welcome to I-Rock 2022. November 5-6. </p>
                    </div>
                </section>
            </Container>
        </div>
    )
}

export default AboutUs